import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import { getMessages } from "../../services/clients";
import MessagesTable from "../../components/Tables/MessagesTable";

export const Messages = () => {
  const { selectedClient } = useContext(AppContext);
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        setMessages(
          await getMessages(selectedClient.public_id ?? selectedClient.id)
        );
      } catch (error) {
        console.error(error);
      }
    };

    console.log("!!! SELECTED CLIENT FROM users: ", selectedClient);
    if (selectedClient) {
      fetchMessages();
    }
    // eslint-disable-next-line
  }, [selectedClient]);
  return (
    <div>
      <MessagesTable messages={messages} />
    </div>
  );
};

export default Messages;
